import React, { Fragment, useState, useEffect } from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { BREAK_POINT } from '../../config/constants';

import Wrapper from './style';

const { Sider } = Layout;

const SideBar = ({ isMain = false, exchange, location, history, children }) => {
    const [pathName, setPathName] = useState('');
    const [isMobile, setIsMobile] = useState(false);

    const handleResize = (e) => {
        const { innerWidth } = window;
        if (innerWidth <= BREAK_POINT && !isMobile) {
            setIsMobile(true);
        } else if (innerWidth > BREAK_POINT && isMobile) {
            setIsMobile(false);
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
    });
    useEffect(() => {
        if (location.pathname) {
            setPathName(location.pathname);
        }
    }, [location, setPathName]);
    useEffect(() => {
        if (isMain
            && exchange.length
            && exchange[0]
            && !exchange[0].is_completed) {
            history.push(`/exchange/setup?id=${exchange[0].id}`)
        }
    }, [exchange, isMain, history])
    useEffect(() => {
        if (pathName.includes('/verify-code')) {
            history.push('/');
        }
    }, [pathName, history])
    if (isMain &&
        (pathName.includes('/exchange/new')
            || pathName.includes('/exchange/setup')
            || pathName.includes('/project')
            || pathName.includes('/wallet')
            || pathName.includes('/confirm-withdraw')
            || pathName.includes('/plugin')
            || pathName.includes('/mypage')
            || exchange.length === 0
        )
    ) {
        return <Fragment />;
    }

    if (isMobile) {
        return null;
    }

    return (
        <Wrapper>
            <Sider width={310} className="sideBar-wrapper">
                {React.cloneElement(children, { pathName, history, location })}
            </Sider>
            <div className='shadow-section'></div>
        </Wrapper>
    );
};

const mapStateToProps = (state) => ({
    exchange: state.exchange
});

export default connect(mapStateToProps)(withRouter(SideBar));
